module.exports = {"menuNameSearch":"Search menu name","searchResultTotal":"{count} results found","noData":"No Data","quickCloseTab":"Quick Close Tab","closeCurrentTab":"Close Current Tab","closeAllTab":"Close All Tabs","closeOtherTab":"Close Other Tabs","closeAllConfirm":"All open tabs will be closed, continue?","closeOtherConfirm":"All other tabs will be closed, continue?","confirm":"OK","cancel":"Cancel","homePage":"Home","call":"Call"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/en-US/tabBar.json
// module id = 7xJT
// module chunks = 1